import axios from 'axios';
import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";

class EquipmentDetails extends Component {
	static contextType = AppContext;
	state = {
		tab: "equipmentDetails",
		idEquipment: "",
		equipmentDetails: [],
		selectedFile: null,
		file: [],
		selectedImages: [],
		image: [],
		imageTitle: "",
		isMain: "0",
		sparePartsData: [],
		sparePartsDateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
		sparePartsDateTo: new Date().toISOString().split('T')[0],
		sparePartsSummary: {
			totalCost: 0,
			totalQuantity: 0,
			totalTransactions: 0
		},
		sparePartsPagination: {
			currentPage: 1,
			totalPages: 0,
			totalRecords: 0,
			limit: 20,
			hasNextPage: false,
			hasPrevPage: false,
			startRecord: 0,
			endRecord: 0
		},
		imageTitle: "",
		sparePartsLoading: false
	}

	componentDidMount() {
		const {
			params: { id }
		} = this.props.match;

		this.setState({ idEquipment: this.props.match.params.id });
		this.getEquipmentDetails(id);
		this.getAllFiles("Equipment_Details", id);
		this.getAllImages(id);
	}

	getEquipmentDetails(idEquipment) {
		fetch(process.env.REACT_APP_API_URL + "equipment/equipment_details/" + idEquipment,
			getGetRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				this.setState({ equipmentDetails: resp, selectedFile: null });
			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}

	setTab = (tabName) => {
		this.setState({ tab: tabName });
		if (tabName === "spareParts") {
			this.getSparePartsDetails();
		}
	}

	getAllFiles(refType, refId) {
		fetch(process.env.REACT_APP_API_URL + "emd/get_all_files/" + refType + "/" + refId,
			getGetRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				this.setState({ file: resp });

			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}

	getAllImages(equipmentId) {
		fetch(process.env.REACT_APP_API_URL + "emd/get_all_asset_images/" + equipmentId,
			getGetRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				this.setState({ image: resp.data });

			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}

	getSparePartsDetails(page = 1) {
		const { idEquipment, sparePartsDateFrom, sparePartsDateTo, sparePartsPagination } = this.state;
		if (!idEquipment) return;

		// Set loading state
		this.setState({ sparePartsLoading: true });

		const url = `${process.env.REACT_APP_API_URL}emd/dashboard/equipment_spare_parts_details?equipmentId=${idEquipment}&dateFrom=${sparePartsDateFrom}&dateTo=${sparePartsDateTo}&page=${page}&limit=${sparePartsPagination.limit}`;
		
		fetch(url, getGetRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				if (resp.success) {
					this.setState({ 
						sparePartsData: resp.data.sparePartsDetails,
						sparePartsSummary: resp.data.summary,
						sparePartsPagination: resp.data.pagination,
						sparePartsLoading: false
					});
				} else {
					console.error("Error fetching spare parts data:", resp.errorMessage);
					this.setState({ sparePartsLoading: false });
				}
			})
			.catch((error) => {
				console.log(error, "catch the hoop");
				this.setState({ sparePartsLoading: false });
			});
	}

	handleInputOnChange = evt => {
		this.setState({ [evt.target.name]: evt.target.value });
	};

	handleSparePartsDateChange = evt => {
		this.setState({ [evt.target.name]: evt.target.value });
	};

	handleSparePartsFilterSubmit = evt => {
		evt.preventDefault();
		this.getSparePartsDetails(1); // Reset to first page when filtering
	};

	handleSparePartsPageChange = (page) => {
		this.getSparePartsDetails(page);
	};

	handleSparePartsPageSizeChange = evt => {
		const newLimit = parseInt(evt.target.value);
		this.setState(prevState => ({
			sparePartsPagination: {
				...prevState.sparePartsPagination,
				limit: newLimit,
				currentPage: 1
			}
		}), () => {
			this.getSparePartsDetails(1);
		});
	};

	onImageSetMainChange = evt => {
		if (this.state.isMain === '1') {
			this.setState({ isMain: '0' });
		}
		else {
			this.setState({ isMain: '1' });
		}
	}
	onFileChange = event => {
		this.setState({ selectedFile: event.target.files[0] });

	};

	// On file upload (click the upload button) 
	onFileUpload = evt => {

		evt.preventDefault();
		Swal.fire({
			title: 'Are you sure?',
			text: 'You want to upload this file',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.isConfirmed) {
				const jwt = this.context.jwt.token;
				const formData = new FormData();

				formData.append(
					"myFile",
					this.state.selectedFile,
					this.state.selectedFile.name,
				);
				formData.append("refType", "Equipment_Details");
				formData.append("refId", this.state.idEquipment);
				var authOptions = {
					method: 'post',
					headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + jwt },
					url: process.env.REACT_APP_API_URL + "emd/file_upload",
					data: formData,

				};
				axios(authOptions)
					.then(response => {
						if (response.data.success === true) {

							Swal.fire({
								icon: 'success',
								title: 'Success',
								text: 'File uploaded successfully',
							})

							this.setState({ selectedFile: null });
							this.getAllFiles("Equipment_Details", this.state.idEquipment);
						}
						else {
							//var errorsMessage = "";
							var errorsMessage = [];

							if (response.data.errorMessage !== undefined && typeof response.data.errorMessage === 'object') {
								var errorsObj = response.data.errorMessage;
								Object.keys(errorsObj).forEach(function (value) {
									errorsObj[value].forEach(function (v) {
										errorsMessage.push(v)
									});

								});

							} else if (response.data.errorMessage !== undefined && (typeof response.data.errorMessage === 'string' || response.data.errorMessage instanceof String)) {

								errorsMessage.push(response.data.errorMessage);
							} else {

								errorsMessage.push("Something went wrong");
							}
							Swal.fire({
								icon: 'error',
								title: response.heading,
								text: errorsMessage,
							})

						}
					})
					.catch((error) => {
						console.log(error, "catch the hoop");
					})
			}
		})
	}

	fileData = () => {

		if (this.state.selectedFile) {

			return (
				<>
					<h3>File Details:</h3>
					<p>File Name: {this.state.selectedFile.name}</p>
					<p>File Type: {this.state.selectedFile.type}</p>
				</>
			);
		}
	};

	removeFile = fileId => evt => {
		evt.preventDefault();
		Swal.fire({
			title: 'Are you sure?',
			text: 'You want to delete this file',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes', 
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.isConfirmed) {
				const jwt = this.context.jwt.token;
				const { ...formData } = this.state;
				const requestOptions = {
					method: 'DELETE',
					headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
					body: JSON.stringify(formData)
				};

				// Show loading state
				Swal.fire({
					title: 'Deleting...',
					html: 'Please wait while the file is being deleted',
					allowOutsideClick: false,
					showConfirmButton: false,
					didOpen: () => {
						Swal.showLoading();
					}
				});

				fetch(process.env.REACT_APP_API_URL + "emd/delete_file/" + fileId, requestOptions)
					.then((resp) => {
						return resp.json()
					})
					.then((resp) => {
						Swal.close();

						if (resp.success === true) {
							Swal.fire({
								icon: 'success',
								title: 'Success',
								text: 'File deleted successfully',
							})
							this.getAllFiles("Equipment_Details", this.state.idEquipment);
						}
						else {
							//var errorsMessage = "";
							var errorsMessage = [];

							if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
								var errorsObj = resp.errorMessage;
								Object.keys(errorsObj).forEach(function (value) {
									errorsObj[value].forEach(function (v) {
										errorsMessage.push(v)
									});

								});

							} else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {

								errorsMessage.push(resp.errorMessage);
							} else {

								errorsMessage.push("Something went wrong");
							}
							Swal.fire({
								icon: 'error',
								title: resp.heading,
								text: errorsMessage,
							})

						}

					})
					.catch((error) => {
						Swal.close();
						Swal.fire({
							icon: 'error',
							title: 'Error',
							text: 'An error occurred while deleting the file'
						});
						console.log(error, "catch the hoop")
					});

			}
		})
	}

	onImageChange = event => {
		this.setState({ selectedImages: Array.from(event.target.files) });
	};
	// On Image upload (click the upload button) 
	onImageUpload = evt => {

		evt.preventDefault();
		
		if (this.state.selectedImages.length === 0) {
			Swal.fire({
				icon: 'warning',
				title: 'No Images Selected',
				text: 'Please select at least one image to upload',
			});
			return;
		}

		Swal.fire({
			title: 'Are you sure?',
			text: `You want to upload`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.isConfirmed) {
				this.uploadImagesSequentially();
			}
		})
	}

	uploadImagesSequentially = async () => {
		const jwt = this.context.jwt.token;

		// Show loading state
		Swal.fire({
			title: 'Uploading...',
			html: 'Please wait while the images are being uploaded',
			allowOutsideClick: false,
			showConfirmButton: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		try {
			const formData = new FormData();
			
			// Append all images to the same field name
			this.state.selectedImages.forEach((image, index) => {
				formData.append("myFile[]", image);
			});
			
			formData.append("refType", "Equipment_Image");
			formData.append("equipmentId", this.state.idEquipment);
			formData.append("capDetailsId", this.state.equipmentDetails.cap_details_id);
			formData.append("title", this.state.imageTitle || "Equipment Image");

			const response = await axios({
				method: 'post',
				headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + jwt },
				url: process.env.REACT_APP_API_URL + "emd/image_upload",
				data: formData,
			});

			Swal.close();

			if (response.data.success === true) {
				const result = response.data.data;
				const successfulUploads = result.successful_uploads;
				const totalFiles = result.total_files;
				
				if (successfulUploads === totalFiles) {
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: `All ${successfulUploads} image(s) uploaded successfully`,
					});
				} else {
					Swal.fire({
						icon: 'warning',
						title: 'Partial Success',
						text: `${successfulUploads} out of ${totalFiles} image(s) uploaded successfully`,
					});
				}
			} else {
				var errorsMessage = [];

				if (response.data.errorMessage !== undefined && typeof response.data.errorMessage === 'object') {
					var errorsObj = response.data.errorMessage;
					Object.keys(errorsObj).forEach(function (value) {
						errorsObj[value].forEach(function (v) {
							errorsMessage.push(v)
						});
					});
				} else if (response.data.errorMessage !== undefined && (typeof response.data.errorMessage === 'string' || response.data.errorMessage instanceof String)) {
					errorsMessage.push(response.data.errorMessage);
				} else {
					errorsMessage.push("Something went wrong");
				}
				
				Swal.fire({
					icon: 'error',
					title: response.data.heading || 'Upload Failed',
					text: errorsMessage,
				});
			}
		} catch (error) {
			Swal.close();
			console.error('Upload error:', error);
			let errorMessage = 'Failed to upload images. Please try again.';
			
			if (error.response && error.response.data) {
				console.error('Server response:', error.response.data);
				if (error.response.data.errorMessage) {
					if (Array.isArray(error.response.data.errorMessage)) {
						errorMessage = error.response.data.errorMessage.join(', ');
					} else {
						errorMessage = error.response.data.errorMessage;
					}
				}
			}
			
			Swal.fire({
				icon: 'error',
				title: 'Upload Failed',
				text: errorMessage,
			});
		}

		// Reset state and refresh images
		this.setState({ selectedImages: [], imageTitle: "", isImageUploading: false });
		this.getAllImages(this.state.idEquipment);
	}


	removeImage = assetImageId => evt => {
		evt.preventDefault();
		Swal.fire({
			title: 'Are you sure?',
			text: 'You want to delete this image',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.isConfirmed) {
				const jwt = this.context.jwt.token;
				const { ...formData } = this.state;
				const requestOptions = {
					method: 'DELETE',
					headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
					body: JSON.stringify(formData)
				};

				// Show loading state
				Swal.fire({
					title: 'Deleting...',
					html: 'Please wait while the image is being deleted',
					allowOutsideClick: false,
					showConfirmButton: false,
					didOpen: () => {
						Swal.showLoading();
					}
				});

				fetch(process.env.REACT_APP_API_URL + "emd/delete_image/" + assetImageId, requestOptions)
					.then((resp) => {
						return resp.json()
					})
					.then((resp) => {
						Swal.close();

						if (resp.success === true) {

							Swal.fire({
								icon: 'success',
								title: 'Success',
								text: 'Image deleted successfully',
							})
							this.getAllImages(this.state.idEquipment);
						}
						else {
							//var errorsMessage = "";
							var errorsMessage = [];

							if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
								var errorsObj = resp.errorMessage;
								Object.keys(errorsObj).forEach(function (value) {
									errorsObj[value].forEach(function (v) {
										errorsMessage.push(v)
									});

								});

							} else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {

								errorsMessage.push(resp.errorMessage);
							} else {

								errorsMessage.push("Something went wrong");
							}
							Swal.fire({
								icon: 'error',
								title: resp.heading,
								text: errorsMessage,
							})

						}

					})
					.catch((error) => {
						Swal.close();
						Swal.fire({
							icon: 'error',
							title: 'Error',
							text: 'An error occurred while deleting the image'
						});
						console.log(error, "catch the hoop")
					});

			}
		})
	}

	isMainChange = assetImageId => evt =>{
		evt.preventDefault();
		const jwt = this.context.jwt.token;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
        };
        fetch(process.env.REACT_APP_API_URL + "emd/set_main_image/" + assetImageId, requestOptions)
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {

                if (resp.success === true) {
                    Swal.fire({
                        position: "top-right",
                        icon: "success",
                        title: "Main Image Changed",
                        showConfirmButton: false,
                        timer: 1500
                    });
					this.getAllImages(this.state.idEquipment);
                }
                else {
                    var errorsMessage = [];

                    if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
                        var errorsObj = resp.errorMessage;
                        Object.keys(errorsObj).forEach(function (value) {
                            errorsObj[value].forEach(function (v) {
                                errorsMessage.push(v)
                            });

                        });

                    } else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {
                        errorsMessage.push(resp.errorMessage);
                    } else {

                        errorsMessage.push("Something went wrong");
                    }
                    Swal.fire({
                        icon: 'error',
                        title: resp.heading,
                        text: errorsMessage,
                    })
                }


            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
	}

	render() {
		//const filehost = process.env.REACT_APP_API_URL.split("api/")[0];
		const filehost = process.env.REACT_APP_AWS_URL + 'emd/';
		const filePath = "Equipment_Details";
		const imagePath = process.env.REACT_APP_AWS_URL + 'asset/';
		return (
			<>
				<div className="card card-custom">
					<div className="card-header">
						<div className="card-title">
							<h3 className="card-label">Equipment Details #{this.state.equipmentDetails.equipment_name}</h3>
						</div>
					</div>
					<div className="ml-12">
						<ul className="nav nav-tabs nav-tabs-line">
							<li className="nav-item" onClick={() => this.setTab("equipmentDetails")}>
								<a className={`nav-link ${this.state.tab === "equipmentDetails" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "equipmentDetails").toString()} href={() => false}>Equipment Info</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("machineDetails")}>
								<a className={`nav-link ${this.state.tab === "machineDetails" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "machineDetails").toString()} href={() => false}>Machine Details</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("engineDetails")}>
								<a className={`nav-link ${this.state.tab === "engineDetails" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "engineDetails").toString()} href={() => false}>Engine Details</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("warranty")}>
								<a className={`nav-link ${this.state.tab === "warranty" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "warranty").toString()} href={() => false}>Warranty</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("manufacturer")}>
								<a className={`nav-link ${this.state.tab === "manufacturer" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "manufacturer").toString()} href={() => false}>Manufacturer</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("fuel")}>
								<a className={`nav-link ${this.state.tab === "fuel" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "fuel").toString()} href={() => false}>Fuel</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("emiInfo")}>
								<a className={`nav-link ${this.state.tab === "emiInfo" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "timeline").toString()} href={() => false}>Emi Info</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("timeline")}>
								<a className={`nav-link ${this.state.tab === "timeline" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "timeline").toString()} href={() => false}>Timeline</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("fileUpload")}>
								<a className={`nav-link ${this.state.tab === "fileUpload" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "fileUpload").toString()} href={() => false}>File Upload</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("imageUpload")}>
								<a className={`nav-link ${this.state.tab === "imageUpload" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "imageUpload").toString()} href={() => false}>Image Upload</a>
							</li>
							<li className="nav-item" onClick={() => this.setTab("spareParts")}>
								<a className={`nav-link ${this.state.tab === "spareParts" && "active"}`} data-toggle="tab" role="tab" aria-selected={(this.state.tab === "spareParts").toString()} href={() => false}>Spare Parts</a>
							</li>
						</ul>

						<div className="col-8 mt-5">
							{this.state.tab === "equipmentDetails" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Equipment Name</th>
											<td>{this.state.equipmentDetails.equipment_name}</td>
										</tr>
										<tr>
											<th>Equipment Code</th>
											<td>{this.state.equipmentDetails.equipment_code}</td>
										</tr>
										<tr>
											<th>Business Unit</th>
											<td>{this.state.equipmentDetails.businessUnit}</td>
										</tr>
										<tr>
											<th>Fixed Asset Code</th>
											<td>{this.state.equipmentDetails.cap_code}</td>
										</tr>
										<tr>
											<th>Country Name</th>
											<td>{this.state.equipmentDetails.countryName}</td>
										</tr>
										<tr>
											<th>Capacity</th>
											<td>{this.state.equipmentDetails.capacity}</td>
										</tr>
										<tr>
											<th>Specs</th>
											<td>{this.state.equipmentDetails.specs}</td>
										</tr>
										<tr>
											<th>Year of Manufacture</th>
											<td>{this.state.equipmentDetails.year_of_manufacture}</td>
										</tr>
										<tr>
											<th>Purchase Date</th>
											<td>{this.state.equipmentDetails.purchase_date}</td>
										</tr>
										<tr>
											<th>Equipment Status</th>
											<td>
												{this.state.equipmentDetails.status === 'active' && <span className="label label-lg label-success label-inline mr-2">Active</span>}
												{this.state.equipmentDetails.status === 'scrap' && <span className="label label-lg label-info label-inline mr-2">Scrap</span>}
												{this.state.equipmentDetails.status === 'sold-out' && <span className="label label-lg label-danger label-inline mr-2">Sold Out</span>}
											</td>
										</tr>
										<tr>
											<th>Remarks</th>
											<td>{this.state.equipmentDetails.remarks}</td>
										</tr>
									</tbody>
								</table>
							}
							{this.state.tab === "emiInfo" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Emi Amount</th>
											<td>{this.state.equipmentDetails.emiAmount}</td>
										</tr>
										<tr>
											<th>Interest Period</th>
											<td>{this.state.equipmentDetails.interestPeriod}</td>
										</tr>
										<tr>
											<th>Interest Rate</th>
											<td>{this.state.equipmentDetails.interestRate}</td>
										</tr>
									</tbody>
								</table>
							}
							{this.state.tab === "machineDetails" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Make</th>
											<td>{this.state.equipmentDetails.makeName}</td>
										</tr>
										<tr>
											<th>Model</th>
											<td>{this.state.equipmentDetails.machine_model}</td>
										</tr>
										<tr>
											<th>Chassis No</th>
											<td>{this.state.equipmentDetails.chassis_number}</td>
										</tr>
										<tr>
											<th>Serial No</th>
											<td>{this.state.equipmentDetails.machine_serial_no}</td>
										</tr>
									</tbody>
								</table>
							}
							{this.state.tab === "engineDetails" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Model</th>
											<td>{this.state.equipmentDetails.model}</td>
										</tr>
										<tr>
											<th>Serial No</th>
											<td>{this.state.equipmentDetails.serial_no}</td>
										</tr>
										<tr>
											<th>HP/KW</th>
											<td>{this.state.equipmentDetails.hp_kw}</td>
										</tr>
									</tbody>
								</table>
							}
							{this.state.tab === "warranty" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Warranty Hour</th>
											<td>{this.state.equipmentDetails.warranty_hour}</td>
										</tr>
										<tr>
											<th>Warranty Start Date</th>
											<td>{this.state.equipmentDetails.warranty_start_date}</td>
										</tr>
										<tr>
											<th>Warranty End Date</th>
											<td>{this.state.equipmentDetails.warranty_end_date}</td>
										</tr>
									</tbody>
								</table>
							}
							{this.state.tab === "manufacturer" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Manufacturer Name</th>
											<td>{this.state.equipmentDetails.manufacturerName}</td>
										</tr>
										<tr>
											<th>Address</th>
											<td>{this.state.equipmentDetails.manufacturer_address}</td>
										</tr>
										<tr>
											<th>Contact No</th>
											<td>{this.state.equipmentDetails.manufacturer_contact_no}</td>
										</tr>
										<tr>
											<th>Email</th>
											<td>{this.state.equipmentDetails.manufacturer_email}</td>
										</tr>
									</tbody>
								</table>
							}
							{this.state.tab === "fuel" &&
								<table className="table table-bordered table-hover">
									<tbody>
										<tr>
											<th>Fuel Type</th>
											<td>{this.state.equipmentDetails.fuelType}</td>
										</tr>
										<tr>
											<th>Tank Capacity</th>
											<td>{this.state.equipmentDetails.tankCapacity}</td>
										</tr>
										<tr>
											<th>Standard Fuel Consumption</th>
											<td>{this.state.equipmentDetails.standardFuelConsumption}</td>
										</tr>
									</tbody>
								</table>
							}
						</div>
						<div className="col-12 mt-5">
							{this.state.tab === "timeline" &&
								<div className="timeline timeline-3">

									<div className="timeline-items" style={{ "height": "600px", "overflow": "auto" }}>
										{
											this.state.equipmentDetails.timeline_history.map((item, index) =>
												<div className="timeline-item" key={index}>
													<div className="timeline-media">
														{item.type === "emo" && <i className="flaticon2-plus text-primary "></i>}
														{item.type === "receive_emo" && <i className="flaticon2-gift text-warning "></i>}
														{item.type === "deny_emo" && <i className="flaticon2-delete text-danger "></i>}
														{item.type === "equipment_release" && <i className="flaticon2-paper-plane text-success "></i>}
														{item.type === "parking_emo" && <i className="flaticon2-map text-info"></i>}
													</div>
													<div className="timeline-content">
														<div className="d-flex align-items-center justify-content-between mb-3">
															<div className="mr-4">
																<span className="mr-3 font-weight-bolder" style={{ "fontSize": "14px", "color": "#e35b5a" }}>
																	Equipment {(item.type === "emo" || item.type === "parking_emo") && <span>Movement Order</span>} has been
																	{item.type === "emo" && item.status === "created" && " Created"}
																	{item.type === "receive_emo" && item.status === "created" && " Received"}
																	{item.type === "deny_emo" && item.status === "created" && " Denied"}
																	{item.type === "equipment_release" && item.status === "created" && " Released"}
																	{item.type === "parking_emo" && " Created"}
																	<span className="text-muted ml-2"> at {item.create_date}</span>
																</span>
																<p className="mr-3 mt-3"> Ref No : <span style={{ color: "#1a34bf" }}><b>{item.ref_no}</b></span></p>
																<p className="mr-3">
																	{item.type === "emo" && <span> Project Name : <b style={{ color: "#2dc51b" }}> {item.sendingBusinessUnit}</b></span>}
																	{item.type === "receive_emo" && item.emoType === "in-house" && <span> Project Name : <b style={{ color: "#2dc51b" }}>{item.receivingBusinessUnit}</b></span>}
																	{item.type === "receive_emo" && item.emoType === "third-party" && <span> Customer Name : <b style={{ color: "#2dc51b" }}>{item.customerName}</b></span>}
																	{item.type === "deny_emo" && <span> Project Name : <b style={{ color: "#2dc51b" }}>{item.receivingBusinessUnit}</b></span>}
																	{item.type === "equipment_release" && item.emoType === "in-house" && <span> Project Name : <b style={{ color: "#2dc51b" }}>{item.receivingBusinessUnit}</b></span>}
																	{item.type === "equipment_release" && item.emoType === "third-party" && <span> Customer Name : <b style={{ color: "#2dc51b" }}>{item.customerName}</b></span>}
																	{item.type === "parking_emo" && item.emoType === "parking" && <><span> Sending Business Unit : <b style={{ color: "#2dc51b" }}>{item.sendingBusinessUnit}</b></span><br></br></>}
																</p>
																{item.type === "parking_emo" && item.emoType === "parking" && <p className="mr-3"><span> Receiving Business Unit : <b style={{ color: "#8950FC" }}>{item.receivingBusinessUnit}</b></span></p>}
																{item.location_id != null && <p className="mr-3"> Location: <b style={{ color: "#ff001b" }}>{item.location}</b></p>}
																<p className="mr-3">
																	{item.type === "emo" && item.status === "created" && <span> Created By : <a href="/#"><b>{item.fullName}</b></a></span>}
																	{item.type === "receive_emo" && item.status === "created" && <span> Received By : <a href="/#"><b>{item.fullName}</b></a></span>}
																	{item.type === "deny_emo" && item.status === "created" && <span> Denied By : <a href="/#"><b> {item.fullName}</b></a></span>}
																	{item.type === "equipment_release" && item.status === "created" && <span> Released By :  <a href="/#"><b>{item.fullName}</b></a></span>}
																	{item.type === "parking_emo" && item.status === "created" && <span> Parked By :  <a href="/#"><b>{item.fullName}</b></a></span>}
																</p>

															</div>
														</div>
													</div>
												</div>
											)
										}
									</div>
								</div>
							}
						</div>
						<div className="col-12 mt-5">
							{this.state.tab === "imageUpload" &&
								<>
								<div className="form-group row mt-5">
										<label htmlFor="imageTitle" className="col-lg-2 col-form-label" >Image Title</label>
										<div className="col-lg-6">
											<div className="input-group input-group-sm">
												<input 
													className="form-control form-control-sm" 
													type="text" 
													name="imageTitle" 
													id="imageTitle" 
													value={this.state.imageTitle} 
													onChange={this.handleInputOnChange}
												/>
											</div>
										</div>
									</div>
									<div className="form-group row">
										<label className="col-lg-2 col-form-label">Upload Images:</label>
										<div className="col-lg-4  col-form-label">
											<input 
												type="file" 
												multiple 
												accept="image/*" 
												onChange={this.onImageChange}
											/>
											<small className="form-text text-muted">You can select multiple images at once</small>
										</div>

									</div>
									<button 
										type="button" 
										className="btn btn-outline-primary btn-sm btn-square mt-1 mr-2" 
										onClick={this.onImageUpload}
									> 
										Upload
									</button>
									<table className="table table-bordered table-hover mt-5">
										<thead>
											<tr>
												<td>Sl</td>
												<td>Image</td>
												<td>File Name</td>
												<td>Title</td>
												<td>Size</td>
												<td>Main Image</td>
												<td style={{ "textAlign": "center" }}>Action</td>
											</tr>
										</thead>
										{this.state.image.length > 0 ?
											<tbody>
												{this.state.image.map((item, index) =>
													<tr key={index}>
														<td>{index + 1}</td>
														<td>
															<img src={`${imagePath}${this.state.equipmentDetails.cap_details_id}/thumb/${item.thumbnailName}`} alt="" style={{ "width": "200px" }} />
														</td>
														<td>{item.originalFileName}</td>
														<td>{item.title}</td>
														<td>{item.fileSize}</td>
														<td className="text-center" onClick={this.isMainChange(item.assetImageId)}>
															{item.isMain === "Yes" &&
																<span className="svg-icon svg-icon-3x svg-icon-success">
																	<SVG
																		src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
																	/>
																</span>}

															{item.isMain === "No" &&
																<span className="svg-icon svg-icon-3x svg-icon-danger">
																	<SVG
																		src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
																	/>
																</span>
															}
														</td>
														<td style={{ "textAlign": "center" }}>
															<a href={`${imagePath}${this.state.equipmentDetails.cap_details_id}/${item.fileName}`} target="_blank" rel="noopener noreferrer" alt="" className="btn btn-outline-primary mr-3"><i className="flaticon2-download-1"></i> Download</a>
															<button type="button" className="btn btn-outline-danger mr-3" onClick={this.removeImage(item.assetImageId)}> <i className="flaticon-delete"></i>Delete</button>
														</td>
													</tr>
												)}
											</tbody>
											:
											<tbody>
												<tr>
													<td colSpan="7"><p style={{ "textAlign": "center" }}><strong>No File Found</strong></p></td>
												</tr>
											</tbody>
										}
									</table>
								</>
							}
							{this.state.tab === "fileUpload" &&
								<>
									<div className="form-group row">
										<label className="col-lg-2 col-form-label">Upload File:</label>
										<div className="col-lg-4  col-form-label">
											<input type="file" onChange={this.onFileChange}
											/>
										</div>

									</div>
									<div className="mt-2 mr-2">
										{this.fileData()}
									</div>
									<button type="button" className="btn btn-outline-primary btn-sm btn-square mt-1 mr-2" onClick={this.onFileUpload}> Upload</button>
									<table className="table table-bordered table-hover mt-5">
										<thead>
											<tr>
												<td>Sl</td>
												<td>Name</td>
												<td>Size</td>
												<td style={{ "textAlign": "center" }}>Action</td>
											</tr>
										</thead>
										{this.state.file.length > 0 ?
											<tbody>
												{this.state.file.map((item, index) =>
													<tr key={index}>
														<td>{index + 1}</td>
														<td>{item.originalFileName}</td>
														<td>{item.fileSize}</td>
														<td style={{ "textAlign": "center" }}>
															<a href={`${filehost}uploads/${filePath}/${this.state.idEquipment}/${item.fileName}`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary mr-3"><i className="flaticon2-download-1"></i> Download</a>
															<button type="button" className="btn btn-outline-danger mr-3" onClick={this.removeFile(item.fileId)}> <i className="flaticon-delete"></i>Delete</button>
														</td>
													</tr>
												)}
											</tbody>
											:
											<tbody>
												<tr>
													<td colSpan="4"><p style={{ "textAlign": "center" }}><strong>No File Found</strong></p></td>
												</tr>
											</tbody>
										}
									</table>
								</>
							}
							{this.state.tab === "spareParts" &&
								<>
									<div className="row mb-4">
										<div className="col-12">
											<h4>Spare Parts Cost Details</h4>
											<form onSubmit={this.handleSparePartsFilterSubmit} className="form-inline">
												<div className="form-group mr-3">
													<label className="mr-2">Date From:</label>
													<input 
														type="date" 
														name="sparePartsDateFrom" 
														value={this.state.sparePartsDateFrom} 
														onChange={this.handleSparePartsDateChange} 
														className="form-control form-control-sm"
													/>
												</div>
												<div className="form-group mr-3">
													<label className="mr-2">Date To:</label>
													<input 
														type="date" 
														name="sparePartsDateTo" 
														value={this.state.sparePartsDateTo} 
														onChange={this.handleSparePartsDateChange} 
														className="form-control form-control-sm"
													/>
												</div>
												<button 
													type="submit" 
													className="btn btn-primary btn-sm"
													disabled={this.state.sparePartsLoading}
												>
													{this.state.sparePartsLoading ? (
														<>
															<span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
															Loading...
														</>
													) : (
														'Filter'
													)}
												</button>
											</form>
										</div>
									</div>
									
									<div className="row mb-4">
										<div className="col-12">
											<div className="card">
												<div className="card-body">
													<div className="row">
														<div className="col-md-3">
															<div className="text-center">
																<h5 className="text-primary">Total Cost</h5>
																<h4>৳ {this.state.sparePartsSummary.totalCost.toLocaleString()}</h4>
															</div>
														</div>
														<div className="col-md-3">
															<div className="text-center">
																<h5 className="text-success">Total Quantity</h5>
																<h4>{this.state.sparePartsSummary.totalQuantity.toLocaleString()}</h4>
															</div>
														</div>
														<div className="col-md-3">
															<div className="text-center">
																<h5 className="text-info">Total Transactions</h5>
																<h4>{this.state.sparePartsSummary.totalTransactions}</h4>
															</div>
														</div>
														<div className="col-md-3">
															<div className="text-center">
																<h5 className="text-warning">Date Range</h5>
																<p>{this.state.sparePartsSummary.dateFrom} to {this.state.sparePartsSummary.dateTo}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* Loading State */}
									{this.state.sparePartsLoading && (
										<div className="row mb-4">
											<div className="col-12">
												<div className="card">
													<div className="card-body text-center">
														<div className="spinner-border text-primary" role="status">
															<span className="sr-only">Loading...</span>
														</div>
														<p className="mt-2 mb-0">Loading spare parts data...</p>
													</div>
												</div>
											</div>
										</div>
									)}

									{/* Content - only show when not loading */}
									{!this.state.sparePartsLoading && (
										<>
											<div className="row mb-3">
										<div className="col-md-6">
											<div className="d-flex align-items-center">
												<span className="mr-2">Show</span>
												<select 
													value={this.state.sparePartsPagination.limit} 
													onChange={this.handleSparePartsPageSizeChange}
													className="form-control form-control-sm"
													style={{width: "70px"}}
													disabled={this.state.sparePartsLoading}
												>
													<option value="10">10</option>
													<option value="20">20</option>
													<option value="50">50</option>
													<option value="100">100</option>
												</select>
												<span className="ml-2">entries</span>
											</div>
										</div>
										<div className="col-md-6">
											<div className="text-right">
												<small className="text-muted">
													Showing {this.state.sparePartsPagination.startRecord} to {this.state.sparePartsPagination.endRecord} of {this.state.sparePartsPagination.totalRecords} entries
												</small>
											</div>
										</div>
									</div>

									<table className="table table-bordered table-hover">
										<thead className="thead-light">
											<tr>
												<th>Serial</th>
												<th>Issue No</th>
												<th>Issue Date</th>
												<th>Item Name</th>
												<th>Item Code</th>
												<th>Quantity</th>
												<th>Unit Rate</th>
												<th>Unit</th>
												<th>Total Amount</th>
											
											</tr>
										</thead>
										{this.state.sparePartsData.length > 0 ?
											<tbody>
												{this.state.sparePartsData.map((item, index) =>
													<tr key={index}>
														<td>{index + 1}</td>
														<td>{item.issueNo}</td>
														<td>{item.issueDate}</td>
														<td>{item.itemName}</td>
														<td>{item.itemCode}</td>
														<td>{item.quantity.toLocaleString()}</td>
														<td>৳ {item.unitRate.toLocaleString()}</td>
														<td>{item.unitName}</td>
														<td>৳ {item.totalAmount.toLocaleString()}</td>
														
													</tr>
												)}
											</tbody>
											:
											<tbody>
												<tr>
													<td colSpan="10"><p style={{ "textAlign": "center" }}><strong>No Spare Parts Data Found</strong></p></td>
												</tr>
											</tbody>
										}
									</table>

									{/* Pagination Controls */}
									{this.state.sparePartsPagination.totalPages > 1 && (
										<div className="row mt-3">
											<div className="col-12">
												<nav aria-label="Spare parts pagination">
													<ul className="pagination justify-content-center">
														<li className={`page-item ${!this.state.sparePartsPagination.hasPrevPage || this.state.sparePartsLoading ? 'disabled' : ''}`}>
															<button 
																className="page-link" 
																onClick={() => this.handleSparePartsPageChange(1)}
																disabled={!this.state.sparePartsPagination.hasPrevPage || this.state.sparePartsLoading}
															>
																First
															</button>
														</li>
														<li className={`page-item ${!this.state.sparePartsPagination.hasPrevPage || this.state.sparePartsLoading ? 'disabled' : ''}`}>
															<button 
																className="page-link" 
																onClick={() => this.handleSparePartsPageChange(this.state.sparePartsPagination.currentPage - 1)}
																disabled={!this.state.sparePartsPagination.hasPrevPage || this.state.sparePartsLoading}
															>
																Previous
															</button>
														</li>
														
														{/* Page Numbers */}
														{(() => {
															const currentPage = this.state.sparePartsPagination.currentPage;
															const totalPages = this.state.sparePartsPagination.totalPages;
															const pages = [];
															
															// Show up to 5 page numbers
															let startPage = Math.max(1, currentPage - 2);
															let endPage = Math.min(totalPages, currentPage + 2);
															
															// Adjust range if we're near the beginning or end
															if (endPage - startPage < 4) {
																if (startPage === 1) {
																	endPage = Math.min(totalPages, startPage + 4);
																} else {
																	startPage = Math.max(1, endPage - 4);
																}
															}
															
															for (let i = startPage; i <= endPage; i++) {
																pages.push(
																	<li key={i} className={`page-item ${i === currentPage ? 'active' : ''} ${this.state.sparePartsLoading ? 'disabled' : ''}`}>
																		<button 
																			className="page-link" 
																			onClick={() => this.handleSparePartsPageChange(i)}
																			disabled={this.state.sparePartsLoading}
																		>
																			{i}
																		</button>
																	</li>
																);
															}
															
															return pages;
														})()}
														
														<li className={`page-item ${!this.state.sparePartsPagination.hasNextPage || this.state.sparePartsLoading ? 'disabled' : ''}`}>
															<button 
																className="page-link" 
																onClick={() => this.handleSparePartsPageChange(this.state.sparePartsPagination.currentPage + 1)}
																disabled={!this.state.sparePartsPagination.hasNextPage || this.state.sparePartsLoading}
															>
																Next
															</button>
														</li>
														<li className={`page-item ${!this.state.sparePartsPagination.hasNextPage || this.state.sparePartsLoading ? 'disabled' : ''}`}>
															<button 
																className="page-link" 
																onClick={() => this.handleSparePartsPageChange(this.state.sparePartsPagination.totalPages)}
																disabled={!this.state.sparePartsPagination.hasNextPage || this.state.sparePartsLoading}
															>
																Last
															</button>
														</li>
													</ul>
												</nav>
											</div>
										</div>
									)}
										</>
									)}
								</>
							}
						</div>
					</div>
				</div>
				{/* <pre>
					{JSON.stringify(this.state, null, 2)}
				</pre> */}
			</>
		);
	}
}

export default EquipmentDetails;